import React from "react";

import styled from "styled-components";

import { Card, CardBody, Col, Container, InputGroup, Row } from "reactstrap";
import PropTypes from "prop-types";
import queryString from "query-string";
import DynamicFormFilters from '../../../../../components/forms/DynamicFormFilters';
import { numberWithCommas } from '../../../../../helpers/utils';
import ReactTableForm from '../../../../../components/Common/ReactTableForm';

const spinnerWidget = (
  <div className="loader-for-react-widget">
    <div className="spinner-border text-primary m-1" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);

const defaultStyle = {
  textAlign: "center",
  width: "auto",
  verticalAlign: "middle",
}

const ServiceProviderDashboard = props => {
  const columns = [
    {
      Header: "Cabinet name",
      src: "cabinet_name",
      accessor: row => {
        return (
          <span>
            {row?.custom_name != null ? row?.custom_name : row.cabinet_name}
          </span>
        );
      },
      isSorted: true,
      style: {
        ...defaultStyle,
        maxWidth: 100,
        minWidth: 100,
      },
    },
    {
      Header: "Cabinet ID",
      src: "cabinet_id",
      accessor: row => {
        return (
          <span>
            {row.cabinet_id}
          </span>
        );
      },
      isSorted: true,
      style: {
        ...defaultStyle,
        maxWidth: 100,
        minWidth: 100,
      },
      Footer: () => (
        <span className={`text-left`} data-toggle="tooltip">
          Total
        </span>
      )
    },
    {
      Header: "Cost",
      src: "spend",
      accessor: row => {
        return (
          <span>
            {numberWithCommas(row.spend)}$
          </span>
        );
      },
      isSorted: true,
      style: {
        ...defaultStyle,
        // maxWidth: 20,
        // minWidth: 20,
      },
    },
    {
      Header: "Cashback",
      src: "cashback",
      accessor: row => {
        return (
          <span>
            {numberWithCommas(row.cashback)}$
          </span>
        );
      },
      isSorted: true,
      style: {
        ...defaultStyle,
        // maxWidth: 20,
        // minWidth: 20,
      },
    },
  ];

  return (
    <>

      <Row>
        {props.serviceData.map((i, k) => (
          <Col
            md={4}
            sm={4}
            key={"_col_" + k}
          >
            <StyledCard className="mini-stats-wid fade-in-custom-animate-1s">
              <CardBody>
                {props.serviceLoader && spinnerWidget}
                <div className="d-flex" style={{ height: "65px" }}>
                  <div className="flex-grow-1">
                    <p className="text-muted fw-medium fade-in-custom-animate">
                      {i.title}
                    </p>
                    <h4 className="mb-0 fade-in-custom-animate">
                      {`${numberWithCommas(i.value)}`}
                    </h4>
                  </div>
                  <div className="d-flex justify-content-end align-items-center">
                    <div className="avatar-xs">
                      <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18 fade-in-custom-animate">
                        <i className={i.icon} />
                      </span>
                    </div>
                  </div>
                </div>
              </CardBody>
            </StyledCard>
          </Col>
        ))}
      </Row>

      <Col className="col-12">
        <Card className="fade-in-custom-animate-1s" style={{ marginBottom: 0 }}>
          <CardBody>
            <React.Fragment>
              <StyledContainer fluid>
                <Row>
                  <Col
                    md={12}
                    sm={12}
                    key={"col_" + 1}
                  >
                    <DynamicFormFilters
                      filterDelay={10}
                      FilterContainerClass="service-provider--filters"
                      onFiltersChange={props.onFiltersChange}
                      onDateRangeChange={props.handleDateRangeChange}
                      filtered_params={queryString.parse(
                        props.history.location.search
                      )}
                      filtersFields={[
                      ]}
                      filtered_by={["contractor", "beneficiary_company"]}
                      selectedDate={[]}
                      dateFilters={[
                        {
                          plug: "Date",
                          key: "date",
                          filterType: ["start_date", "end_date"],
                          value: props.defDate,
                          clearDate: false,
                          pickerName: "service-provider",
                          dateRange: true,
                          customWidth: `200px`,
                        },
                      ]}
                      style={{
                        backgroundColor: '#fff'
                      }}
                      disableFilterBy
                    />
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    key={"col_" + 1}
                  >
                    {props.serviceLoader ? (
                      <div className="table-loader fade-in-custom-animate-1s" style={{ height: 100 }}>
                        {spinnerWidget}
                      </div>
                    ) : (
                      <ReactTableForm
                        columns={columns}
                        data={props.table_data}
                        onTableChange={props.handleTableChange}
                        pagination={false}
                        className="service-provider--table"
                        firstIsSticky
                        // withFooter
                      />
                    )}
                  </Col>
                </Row>
              </StyledContainer>
            </React.Fragment>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

const StyledContainer = styled(Container)`
    .loader-for--line-chart {
      transition: opacity 0.3s;
      opacity: 1;
      backdrop-filter: blur(4px);
      display: flex;
      width: 98%;
      height: 350px;
      position: absolute;
      z-index: 1;
    }

    .service-provider--table {
      padding: 0 !important;
    }

    .table-loader {
      display: flex;
      justify-content: center;
    }
  `;

const StyledCard = styled(Card)`
.loader-for-react-widget {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 1;
}
`;

ServiceProviderDashboard.propTypes = {
  history: PropTypes.any,
  permissions: PropTypes.any,
  serviceData: PropTypes.array,
  serviceLoader: PropTypes.bool,
  handleDateRangeChange: PropTypes.func,
  onFiltersChange: PropTypes.func,
  defDate: PropTypes.object,
  handleTableChange: PropTypes.func,
  table_data: PropTypes.object
};

export default ServiceProviderDashboard;
